import React from "react";
import GridToolbarNoExport from "../../../common/GridToolbarNoExport";
import AppDataGrid from "../../../common/AppDataGrid";
import { CircularProgress, Typography, Box } from "@mui/material"; // Import necessary MUI components
import useFirestore from "../../../../config/fireBaseHook"; // Correct path to useFirestore hook
// Removed moment import as useFirestore handles date formatting

const NewCourseRequests = () => {
  // Use useFirestore to fetch data from 'NewCourseRequest' collection, ordered by 'createdAt' descending
  const { data, loading, error } = useFirestore(
    "NewCourseRequests",
    "Date_Submitted",
    "desc",
  );

  const columns = [
    {
      field: "Date_Submitted", // Use 'createdAt' from Firestore (formatted by the hook)
      headerName: "Date Submitted",
      width: 150,
      // valueFormatter: (params) => params.value ? new Date(params.value).toLocaleDateString() : '', // Formatting handled by hook
    },
    {
      field: "courseRequest",
      headerName: "Course Request",
      flex: 1,
    },
    {
      field: "startDate", // Assumes hook formats date strings
      headerName: "Start Date",
      width: 120,
    },
    {
      field: "endDate", // Assumes hook formats date strings
      headerName: "End Date",
      width: 120,
    },
    {
      field: "modality",
      headerName: "Modality",
      width: 120,
    },
    {
      field: "instructorType",
      headerName: "Instructor Type",
      width: 130,
    },
    {
      field: "instructorName",
      headerName: "Instructor Name",
      flex: 1,
    },
    {
      field: "startTime",
      headerName: "Start Time",
      width: 100,
    },
    {
      field: "endTime",
      headerName: "End Time",
      width: 100,
    },
    {
      field: "daysOfWeek",
      headerName: "Days of Week",
      flex: 1,
    },
    {
      field: "schoolName",
      headerName: "School Name",
      flex: 1,
    },
    {
      field: "fromName",
      headerName: "From Name",
      flex: 1,
    },
    {
      field: "schoolId",
      headerName: "School ID",
      width: 100,
    },
    {
      field: "notes", // Added notes field
      headerName: "Notes",
      flex: 1,
    },
    // Add other fields from your NewCourseRequest collection as needed
  ];

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
        <Typography color="error">Error loading data: {error}</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ height: 600, width: "100%" }}>
      {" "}
      {/* Adjust height as needed */}
      <AppDataGrid
        rows={data} // Data comes directly from useFirestore
        columns={columns}
        loading={loading}
        slots={{ toolbar: GridToolbarNoExport }}
        pagination // Keep pagination enabled
        initialState={{
          // Set initial pagination state
          pagination: {
            paginationModel: { pageSize: 25, page: 0 }, // Default page size
          },
        }}
        pageSizeOptions={[10, 25, 50, 100]} // Options for page size
        disableRowSelectionOnClick // Keep this prop if needed
        getRowId={(row) => row.id} // Ensure each row has a unique ID (useFirestore provides 'id')
      />
    </Box>
  );
};

export default NewCourseRequests;
